/**
 * Open a window with a share functionality for a social service (Facebook, Twitter, Pinterest),
 * when clicking on a link/button.
 *
 * @requires utilities.url
 */

define('libs/socialbutton',['require'],function(require) {

    'use strict';

    var SETTINGS = {
        windowsize: {
            facebook: [700, 300],
            twitter: [700, 300],
            pinterest: [700, 300]
        }
    };

    /**
     * @class SocialButton
     * @param {Element} element The SocialButtons root element (form).
     * @param {String} type The social service (facebook, twitter, etc.).
     * @param {BuyComponent} buy_now The buy now component that fires event about product changes.
     */
    var SocialButton = function(element, type, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.$element = $(element);
        this.type = type;
        this.url = element.href;

        // when the share button is clicked, open a window for the appropriate social media.
        this.$element.on('click', function(event) {
            if (SETTINGS.windowsize[this.type]) {
                event.preventDefault();
                if (this.url) {
                    this.openWindow(this.url, this.getPopupSettings(this.type));
                }
            }
        }.bind(this));
    };

    /**
     * Get the settings for the window we need to open.
     * Gives a top en left so the window wil be centered in the viewport.
     * @param {String} type The share type, e.g. 'facebook', 'twitter', 'pinterest'.
     * @return {{width: Number, height: Number, top: Number, left: Number}}
     * @memberof SocialButton
     */
    SocialButton.prototype.getPopupSettings = function(type) {
        return {
            width: SETTINGS.windowsize[type][0],
            height: SETTINGS.windowsize[type][1],
            top: (window.innerHeight / 2) - (SETTINGS.windowsize[type][1] / 2),
            left: (window.innerWidth / 2) - (SETTINGS.windowsize[type][0] / 2)
        };
    };

    /**
     * Open the window for the social media service.
     * @param {Object} settings The settings for the window.
     * @param {String} url The url for the window.
     * @memberof SocialButton
     */
    SocialButton.prototype.openWindow = function(url, settings) {
        window.open(url, '', 'width=' + settings.width +
            ', height=' + settings.height +
            ', left=' + settings.left +
            ', top=' + settings.top);
    };


    return SocialButton;
});

